import Controller from "./utilizationBar.controller";
import template from "./utilizationBar.html";

const utilizationBar = {
  template,
  controller: Controller,
  bindings: {
    capacity: "<",
  },
};

export default utilizationBar;



// WEBPACK FOOTER //
// ./src/components/utilizationBar/utilizationBar.component.js